  
export function PolicyModel() {
    this.mainClass = "";
    this.mainClassName = "";
    this.subClass = "";
    this.policyType = "";
    this.policyPlan = "";
    this.policyCategory = "";
    this.insureName = "";
    this.policyNo = "";
    this.effectiveDate = "";
    this.expireDate = "";
    this.active = "";
    this.taxReceiptDate = "";
    this.premium = "";
    this.renewStatus = "";
    this.mobile = "";
    this.poc = "";
    this.juristic = "";
    this.policyDesc = "";
    this.coverage = "";  
    this.policyDocDesc = []
    this.isConfirm = null;
    this.jacket = null;
    this.endosements = []
 
    this.setValue = function (data) {
        this.mainClass = data.main_class || "";
        this.mainClassName = data.main_class_name;
        this.subClass = data.sub_class;
        this.policyType = data.policy_type;
        this.policyPlan = data.insure_name;
        this.policyNo = data.policy_no;
        this.policyCategory = data.policy_category;
        this.effectiveDate = data.effective_date;
        this.expireDate = data.expire_date;
        this.active = data.active;
        this.taxReceiptDate = data.tax_receipt_date;
        this.premium = data.premium;
        this.renewStatus = data.renew_status;
        this.mobile = data.mobile;
        this.poc = data.poc;
        this.juristic = data.juristic;
        this.policyDesc = data.policy_desc;
        this.coverage = data.coverage;
        this.isConfirm = data.isConfirm;
        this.jacket = data.jacket;
        this.endosements = data.Endosements;

        for (let j = 0; j < data.PolicyDoc_desc.length; j++) {
            let doc = data.PolicyDoc_desc[j];

            let policyDoc = new PolicyDocDesc();
            policyDoc.setValue(doc);

            this.policyDocDesc.push(policyDoc);
        }
    }; 
} 

export function PolicyDocDesc() {
    this.cizitenId = "";
    this.documentId = "";
    this.originalUrl = "";
    this.url = "";
    this.docType = "";
    this.supDocType = ""; 
    this.name = "";
 
    this.setValue = function (data) { 
        this.cizitenId = data.CizitenId || "";
        this.documentId = data.DocumentId || "";
        this.originalUrl = data.OriginalUrl || "";
        this.url = data.URL || "";
        this.docType = data.docType || "";
        this.supDocType = data.supDocType || "";
        this.name  = data.name || "";
    }; 
}

export function PolicyRenews() {
    this.cizitenId = "";
    this.documentId = "";
    this.originalUrl = "";
    this.url = "";
    this.docType = "";
    this.supDocType = ""; 
    this.name = "";
    this.policyNoolicyNo = "";
    this.policyCategory = "";
 
    this.setValue = function (data) { 
        this.cizitenId = data.CizitenId || "";
        this.documentId = data.DocumentId || "";
        this.originalUrl = data.OriginalUrl || "";
        this.url = data.Url || "";
        this.docType = data.DocType || "";
        this.supDocType = data.SubDocType || "";
        this.name  = data.Name || "";
        this.policyNo = data.PolicyNo || "";
        this.policyCategory = data.PolicyCategory || "";
    }; 
} 

